import currency from 'currency.js'

export const toBarChartData = data => {
  if (!data) return {}
  let totalCount = 0
  let totalBidValue = 0
  const keys = ['Lost']
  const barByValue = Object.keys(data).reduce((a, item) => {
    const elem = data[item]
    totalBidValue += elem.totalBidValue
    totalCount += elem.count
    a.push({
      month: item,
      Lost: currency(elem.totalBidValue).value
    })

    return a
  }, [])

  return {
    keys,
    barByValue,
    totalCount,
    totalBidValue
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const getColors = bar => {
  const colors = { Lost: '#595959' }
  return colors[bar.id]
}
